import React, { useState } from 'react';
import { Modal, Form, Input, Select, InputNumber, message } from 'antd';
import { McpServerConfigVo, McpServerConfigCreateReq, McpServerConfigUpdateReq, createMcpServerConfig, updateMcpServerConfig } from '@/api/mcpServer';

export interface EditMcpServerProp {
  data?: McpServerConfigVo;
  isEdit: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditMcpServerModal = ({ data, isEdit, updateFn, onCancel }: EditMcpServerProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    form.validateFields().then(values => {
      setLoading(true);
      if (isEdit && data) {
        const req: McpServerConfigUpdateReq = {
          id: data.id,
          ...values,
        };
        updateMcpServerConfig(req)
          .then(() => {
            message.success('更新成功');
            updateFn();
            onCancel();
          })
          .finally(() => setLoading(false));
      } else {
        const req: McpServerConfigCreateReq = {
          ...values,
        };
        createMcpServerConfig(req)
          .then(() => {
            message.success('创建成功');
            updateFn();
            onCancel();
          })
          .finally(() => setLoading(false));
      }
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑 MCP Server' : '新增 MCP Server'}
      open={true}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={
          isEdit && data
            ? {
                serverName: data.serverName,
                displayName: data.displayName,
                description: data.description,
                serverUrl: data.serverUrl,
                transportType: data.transportType || 'sse',
                authType: data.authType,
                connectTimeout: data.connectTimeout || 30000,
                requestTimeout: data.requestTimeout || 60000,
              }
            : {
                transportType: 'sse',
                connectTimeout: 30000,
                requestTimeout: 60000,
              }
        }
      >
        <Form.Item
          name="serverName"
          label="服务名称"
          rules={[{ required: true, message: '请输入服务名称' }]}
        >
          <Input placeholder="唯一标识，如 ai-tool-mcp-server" disabled={isEdit} />
        </Form.Item>
        <Form.Item name="displayName" label="显示名称">
          <Input placeholder="如 AI工具MCP服务" />
        </Form.Item>
        <Form.Item name="description" label="描述">
          <Input.TextArea placeholder="服务描述" rows={2} />
        </Form.Item>
        <Form.Item
          name="serverUrl"
          label="服务地址"
          rules={[{ required: true, message: '请输入服务地址' }]}
        >
          <Input placeholder="SSE地址，如 http://localhost:9091/sse" />
        </Form.Item>
        <Form.Item name="transportType" label="传输类型">
          <Select options={[{ label: 'SSE', value: 'sse' }, { label: 'WebSocket', value: 'websocket' }]} />
        </Form.Item>
        <Form.Item name="authType" label="认证类型">
          <Select
            options={[
              { label: '无认证', value: 'none' },
              { label: 'Bearer Token', value: 'bearer' },
              { label: 'Basic Auth', value: 'basic' },
            ]}
            allowClear
          />
        </Form.Item>
        <Form.Item name="connectTimeout" label="连接超时(ms)">
          <InputNumber min={1000} max={120000} step={1000} />
        </Form.Item>
        <Form.Item name="requestTimeout" label="请求超时(ms)">
          <InputNumber min={1000} max={300000} step={1000} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditMcpServerModal;